import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://a2insure.com/api/uploads/10cf2a29a027490e8559d1f36cc40701.svg";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#002147] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand */}
          <div>
            <div className="mb-6">
              <img src={LOGO_URL} alt="Anderson & Anderson Insurance LLC" className="h-16 w-auto object-contain" />
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Protecting what matters most since 2017. Serving Northwest Indiana, Chicagoland, and clients across Indiana, Illinois, Michigan, Ohio & Florida.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6 text-[#D4AF37]">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About Us" },
                { to: "/products", label: "Our Products" },
                { to: "/blog", label: "Blog" },
                { to: "/contact", label: "Get a Quote" },
                { to: "/appointments", label: "Schedule Appointment" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                    className="text-white/60 hover:text-[#D4AF37] text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6 text-[#D4AF37]">Products</h4>
            <ul className="space-y-3">
              {["Home Insurance", "Auto Insurance", "Commercial Insurance", "Life Insurance", "Health Insurance", "Annuities", "LegalShield", "Long-term Care", "Travel Insurance"].map((product) => (
                <li key={product}>
                  <Link
                    to="/products"
                    className="text-white/60 hover:text-[#D4AF37] text-sm transition-colors"
                  >
                    {product}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6 text-[#D4AF37]">Contact Us</h4>
            <div className="space-y-4">
              <a href="tel:2197797040" className="flex items-start gap-3 text-white/60 hover:text-white text-sm transition-colors">
                <Phone className="h-4 w-4 text-[#D4AF37] mt-0.5 shrink-0" />
                (219) 779-7040
              </a>
              <a href="mailto:customerservice@a2insure.com" className="flex items-start gap-3 text-white/60 hover:text-white text-sm transition-colors">
                <Mail className="h-4 w-4 text-[#D4AF37] mt-0.5 shrink-0" />
                customerservice@a2insure.com
              </a>
              <div className="flex items-start gap-3 text-white/60 text-sm">
                <MapPin className="h-4 w-4 text-[#D4AF37] mt-0.5 shrink-0" />
                <span>10971 Four Seasons Pl, Ste 216<br />Crown Point, IN 46307</span>
              </div>
              <div className="flex items-start gap-3 text-white/60 text-sm">
                <MapPin className="h-4 w-4 text-[#D4AF37] mt-0.5 shrink-0" />
                <div>
                  <span>Elmhurst, IL</span><br />
                  <a href="tel:3129374444" className="hover:text-white transition-colors">(312) 937-4444</a>
                </div>
              </div>
              <div className="flex items-start gap-3 text-white/60 text-sm">
                <MapPin className="h-4 w-4 text-[#D4AF37] mt-0.5 shrink-0" />
                <div>
                  <span>Naples, FL</span><br />
                  <a href="tel:2395252712" className="hover:text-white transition-colors">(239) 525-2712</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            &copy; {new Date().getFullYear()} Anderson & Anderson Insurance LLC. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="/privacy-policy" className="text-white/40 hover:text-[#D4AF37] text-sm transition-colors">Privacy Policy</a>
            <a href="/terms" className="text-white/40 hover:text-[#D4AF37] text-sm transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
<div className="flex justify-center space-x-6 mt-8 pt-8 border-t border-slate-700">
  <a href="https://www.facebook.com/961538087359888" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-white transition-colors">Facebook</a>
  <a href="https://www.facebook.com/1288345384373231" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-white transition-colors">Facebook — Florida</a>
  <a href="https://www.instagram.com/a2insurellc" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-white transition-colors">Instagram</a>
  <a href="https://www.youtube.com/@InsuranceExplainedbyA2" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-white transition-colors">YouTube</a>
</div>
    </footer>
  );
}
